module.exports = __webpack_public_path__ + "static/media/2.e70fd572.jpg";